import { RoundedButton, type RoundedButtonProps } from '../buttons';

export type DocumentToolbarButtonProps = RoundedButtonProps;

export const DocumentToolbarButton = RoundedButton;
